<template>
  <div class="site-width">
    <h1 class="text-h4 text-center q-py-sm">
      {{ $t('Reset your password') }}
    </h1>
    <div
      v-if="done"
      class="text-center q-pa-sm"
    >
      <p>{{ $t('Your password is updated.') }}</p>
      <p>
        <router-link :to="{ name: 'login' }">
          Back to Login
        </router-link>
      </p>
    </div>
    <template v-else>
      <form-reset-password
        ref="form"
        @submit="onFormSubmit"
        :loading="isProcessing"
        v-if="keyStatus === 'ACTIVE'"
        class="form form-reset-password"
      />
      <div v-else-if="keyStatus === 'EXPIRED'">
        <p>
          Reset link expired. Try
          <router-link :to="{ name: 'forgot-password' }">
            again
          </router-link>.
        </p>
      </div>
      <div v-else-if="keyStatus === 'USED'">
        <p>
          Reset Link has been already used. Go back to
          <router-link :to="{ name: 'login' }">
            Login
          </router-link>.
        </p>
      </div>
      <div v-else-if="['NOT_EXISTS', 'INVALID'].includes(keyStatus)">
        <p>
          Invalid Reset Link. Go back to
          <router-link :to="{ name: 'login' }">
            Login
          </router-link>.
        </p>
      </div>
      <div v-else>
        Please, wait...
      </div>
    </template>
  </div>
</template>
<script>
import Vue from 'vue';
import Component from 'vue-class-component';

import { mapActions } from 'vuex';
import FormResetPassword from '@/components/forms/FormResetPassword';

@Component({
  name: 'page-reset-password',
  components: {
    FormResetPassword,
  },
  methods: mapActions(['userResetPassword', 'userValidateResetKey']),
})
export default class PageResetPassword extends Vue {
  done = false;
  isProcessing = false;
  isKeyInvalid = false;
  keyStatus = '';

  async created() {
    const { status } = await this.userValidateResetKey(this.$route.params.key);
    this.keyStatus = status;
  }

  async onFormSubmit(payload) {
    this.isProcessing = true;
    try {
      await this.userResetPassword(payload);
      this.done = true;
    } catch (error) {
      console.error(error);
      this.$refs.form.setError(this.$t('errors.wrong_credentials'));
    }
    this.isProcessing = false;
  }
}
</script>
